import React from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import styles from "./TemplateCreate.module.css";
import {
  FiArrowLeft,
  FiSmartphone,
  FiMessageSquare,
  FiZap,
  FiPhone,
  FiMail,
  FiList,
  FiArrowRight,
} from "react-icons/fi";

const TemplateCreate = () => {


  return (
    <DashboardLayout>
      <main className="content">
        <div className="container-fluid p-0">

          {/* PAGE HEADER */}
          <div className={styles.header}>
            <div className={styles.headerLeft}>
              <Link to="/dashboard/template" className={styles.back}>
                <FiArrowLeft />
              </Link>
              <h2>Template Report</h2>
            </div>

            <Link
              to="/dashboard/template-view"
              className="qw-btn qw-btn--soft"
            >
              <span className="qw-btn__icon">
                <FiList size={16} />
              </span>
              View Template List
            </Link>
          </div>

          {/* CARDS */}
          <div className="row g-4 mt-4">
            <div className="col-xl-4 col-lg-4 col-md-6 mb-4">
              <Link to="/dashboard/sms-template" className={styles.card}>
                <div className={`${styles.icon} ${styles.blue}`}>
                  <FiSmartphone />
                </div>
                <div className={styles.title}>SMS</div>
                <div className={styles.desc}>
                  Fast, reliable text messaging for OTPs and alerts.
                </div>
                <div className={styles.cta}>Select <FiArrowRight size={14} /></div>
              </Link>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 mb-4">
              <Link
                to="/dashboard/create-whatsapp-template-new"
                className={styles.card}
              >
                <div className={`${styles.icon} ${styles.green}`}>
                  <FiMessageSquare />
                </div>
                <div className={styles.title}>WHATSAPP</div>
                <div className={styles.desc}>
                  Rich media, high-engagement customer conversations.
                </div>
                <div className={styles.cta}>Select <FiArrowRight size={14} /></div>
              </Link>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 mb-4">
              <Link to="/dashboard/create-rcs-template" className={styles.card}>
                <div className={`${styles.icon} ${styles.purple}`}>
                  <FiZap />
                </div>
                <div className={styles.title}>RCS</div>
                <div className={styles.desc}>
                  Next-gen interactive rich messaging for Android.
                </div>
                <div className={styles.cta}>Select <FiArrowRight size={14} /></div>
              </Link>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 mb-4">
              <Link
                to="/dashboard/voice-template"
                className={styles.card}
              >
                <div className={`${styles.icon} ${styles.orange}`}>
                  <FiPhone />
                </div>
                <div className={styles.title}>VOICE</div>
                <div className={styles.desc}>
                  Automated voice calls and interactive menus.
                </div>
                <div className={styles.cta}>Select <FiArrowRight size={14} /></div>
              </Link>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 mb-4">
              <Link
                to="/dashboard/email-template"
                className={styles.card}
              >
                <div className={`${styles.icon} ${styles.indigo}`}>
                  <FiMail />
                </div>
                <div className={styles.title}>EMAIL</div>
                <div className={styles.desc}>
                  Comprehensive rich emails and newsletters.
                </div>
                <div className={styles.cta}>Select <FiArrowRight size={14} /></div>
              </Link>
            </div>
          </div>

        </div>
      </main>
    </DashboardLayout>
  );
};

export default TemplateCreate;
